<template>
    <div class="h-full flex flex-col justify-center">
        <select :id="id" v-model="value" :disabled="disabled" :aria-label="ariaLabel" :aria-describedby="describedBy" class="hover:opacity-85 bg-white w-auto disabled:opacity-75">
            <option v-if="!value && !choices.some((choice) => choice[0] === value)" :selected="!value" :value="''" disabled>Select preference</option>
            <option v-for="choice in choices" :key="choice[0]" :value="choice[0]" :lang="choice[2]" :selected="choice[0] === value">{{ choice[1] }}</option>
        </select>
    </div>
</template>

<script setup>
const value = defineModel({ type: String, required: true, default: "" });
defineProps({
    id: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    choices: {
        type: Array,
        default: () => [],
    },
    ariaLabel: {
        type: String,
        required: true,
    },
    describedBy: {
        type: String,
        default: undefined,
    },
});
</script>
